import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=162c3986&"
import script from "./Menu.vue?vue&type=script&lang=js&"
export * from "./Menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/fared/kowamas-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('162c3986')) {
      api.createRecord('162c3986', component.options)
    } else {
      api.reload('162c3986', component.options)
    }
    module.hot.accept("./Menu.vue?vue&type=template&id=162c3986&", function () {
      api.rerender('162c3986', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/header/Menu.vue"
export default component.exports